/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "./Lang"
import BaseCom from "./BaseCom";
import './PDFModal.css';


export const PDFModalGlobal = {
    show(url) { }
}

export class PDFModal extends BaseCom {

    constructor(props) {
        super(props);
        this.state = { show: false, url: '' };
        PDFModalGlobal.show = this.show.bind(this);
    }

    show(url, downloadFunction) {
        this.setState({ show: true, url: url, downloadFunction: downloadFunction });
    }

    hide = () => {
        this.setState({ show: false });
    }

    render() {
        if(!this.state.show)
            return null;
        return (
            <div className="PDFModal">
                {this.state.downloadFunction && <div className="actions d-flex justify-content-between">
                    <button className="btn btn-secondary" onClick={this.hide}><L>Cancel</L></button>
                    <button className="btn btn-primary" onClick={this.state.downloadFunction}><L>Download</L></button>
                </div>}
                <div className="view-wrapper">
                    <iframe src={this.state.url} width="100%" height="600px" title="Document"></iframe>
                </div>
            </div>
            );
    }
}